







import Vue from "vue";
import Displayed from "./Displayed.vue";

export default Vue.extend({
  name: "FriendInfo",
  props: ["info", "playerNumber", "playerTurn"],
  components: { Displayed }
});
